import { GameVars } from "../GameVars";
import { GameManager } from "../GameManager";
import { RewardItem } from "./RewardItem";

export class DailyRewardItemsContainer extends Phaser.Group {

    public static trunkHit: boolean;

    private static ITEMS_COORDINATES = [
        [85, 560],
        [195, 650],
        [315, 710],
        [455, 710],
        [585, 650],
        [685, 560]
    ];

    constructor(game: Phaser.Game) {

        super(game, null, "daily-reward-container", false);

        DailyRewardItemsContainer.trunkHit = false;

        this.scale.y = GameVars.scaleY;

        var rewardTypes = GameManager.determineDailyRewardsItems();

        for (let i = 0; i < rewardTypes.length; i++) {

            let px = DailyRewardItemsContainer.ITEMS_COORDINATES[i][0];
            let py = DailyRewardItemsContainer.ITEMS_COORDINATES[i][1];

            let rewardItem = new RewardItem(this.game, px, py, rewardTypes[i]);
            this.add(rewardItem);
        }
    }

    public openTrunks(): void {

        this.forEach(function (rewardItem: RewardItem) {

            if (!rewardItem.trunkHit) {
                rewardItem.openTrunk();
            }

        }, this);
    }
}
